module.exports = __webpack_public_path__ + "static/media/loading0.e24204a2.gif";